import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import CartDrawer from "./components/CartDrawer";
import AuthCallback from "./pages/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";

import HomePage from "./pages/HomePage";
import RepairPage from "./pages/RepairPage";
import ContactPage from "./pages/ContactPage";
import DevisPage from "./pages/DevisPage";
import MagasinsPage from "./pages/MagasinsPage";
import AccessoiresPage from "./pages/AccessoiresPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";

import { iphoneData, macData, ipadData, watchData } from "./data/repairData";

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/33611367002"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-btn"
        title="Nous contacter sur WhatsApp"
        className="fixed bottom-36 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 transition-all duration-200 hover:scale-110"
        style={{ background: "#25D366" }}
      >
        <svg viewBox="0 0 24 24" className="w-7 h-7" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
      <ChatWidget />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect Google Auth callback synchronously to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/reparation/iphone" element={<Layout><RepairPage data={iphoneData} repairType="Smartphone" /></Layout>} />
      <Route path="/reparation/mac" element={<Layout><RepairPage data={macData} repairType="Laptop" /></Layout>} />
      <Route path="/reparation/ipad" element={<Layout><RepairPage data={ipadData} repairType="Tablet" /></Layout>} />
      <Route path="/reparation/apple-watch" element={<Layout><RepairPage data={watchData} repairType="Watch" /></Layout>} />
      <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
      <Route path="/devis" element={<Layout><DevisPage /></Layout>} />
      <Route path="/nos-magasins" element={<Layout><MagasinsPage /></Layout>} />
      <Route path="/accessoires" element={<Layout><AccessoiresPage /></Layout>} />
      <Route path="/paiement/succes" element={<PaymentSuccessPage />} />
      <Route path="/paiement/annule" element={<PaymentCancelPage />} />
      <Route path="/connexion" element={<AuthPage />} />
      <Route path="/profil" element={<ProfilePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <CartDrawer />
            <ScrollToTop />
            <AppRouter />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
